import { textVariants } from "@/src/components/Text/Text";
import mark from "@assets/greenmark.svg";
import { useTranslation } from "react-i18next";

interface Props {
  type: string;
  message?: string;
}

const TradeSuccess = ({ type, message }: Props) => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.components.b2cTradeSuccess.${key}`);
  return (
    <div>
      <div className="flex w-full flex-col items-center">
        <img className="h-20 w-20" src={mark} alt="hourglass" />
        <div className="text-center">
          <p className={textVariants({ font: "semibold" })}>
            {type === "buy" ? trans("buy.title") : trans("sell.title")}
          </p>
          <p className={textVariants({ variant: "desc", size: "sm" })}>
            {type === "buy" ? trans("buy.desc") : message ?? trans("sell.desc")}
          </p>
        </div>
      </div>
      {/* You can customize the display or add additional components here */}
    </div>
  );
};

export default TradeSuccess;
